import { useSelector } from 'react-redux';
import * as Service from 'services/log';

export const useLogService = () => {
  const { token } = useSelector((state) => state.user_data);

  const read = async (options = {}) => {
    const { error, payload } = await Service.read({
      ...options,
      token
    });

    if (error) {
      return { logs: [], size: 0 };
    }

    return { logs: payload.data, size: payload.meta.size };
  };

  const readById = async (id, options = {}) => {
    return await Service.readById(id, {
      ...options,
      token
    });
  };

  const search = async (keys, keywords, options = {}) => {
    return await Service.search(keys, keywords, {
      ...options,
      token
    });
  };

  const update = async (id, options = {}) => {
    return await Service.updateById(id, {
      ...options,
      token
    });
  };

  return { read, readById, update, search };
};
